import gql from 'graphql-tag';

const GET_TAGS = gql`
  query GetTags {
    getTags {
      id
      name
      description
      group_id
    }
  }
`;

const GET_TAGGED_WORD_HISTORY = gql`
  query GetTaggedHistory($student_book_id: Int!) {
    getTaggedWordHistory(student_book_id: $student_book_id) {
      id
      lesson_id
      message_id
      word
      created_at
      deleted_at
      updated_at
      tags {
        name
        teacher_tagged_word_id
        vocabulary_tag_id
      }
    }
  }
`;

export { GET_TAGS, GET_TAGGED_WORD_HISTORY };
